import { Route, Routes } from "react-router-dom";
import DashboardRouter from "./Dashboard";

export default function HomeRouter({
  targetParentProfile,
  showViewingParentLabel = false,
}) {
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <DashboardRouter
            targetParentProfile={targetParentProfile}
            showViewingParentLabel={showViewingParentLabel}
          />
        }
      />
    </Routes>
  );
}
